export default __webpack_public_path__ + "media/top-bg.6c7673f9.png";